import {useTranslations} from 'next-intl';
import PreFooter from '@/prefooter';
import Link from '@/links';
import {withMarginBottomZeroToSm} from '@/hocs/withSpacing';
import prefooterStyles from '../../../prefooter/styles.module.scss';

const CtaDefaultMarginedMob = withMarginBottomZeroToSm(Link);

const assetVersion = process.env.ASSET_VERSION || 'defaultVersion';

const PrefooterSection = () => {
  const t = useTranslations('industryRealEstate.prefooter');
  const sharedT = useTranslations('shared');

  return (
    <PreFooter title={t('title')} subtitle="" backgroundImg={`prefooter-bg.jpg?v=${assetVersion}`}>
      <ul className={prefooterStyles['list-inline-to-bl']}>
        <li>
          <CtaDefaultMarginedMob
            href="/free-trial"
            variant="cta-default-xs"
            customAttributes={{
              'data-gtm': 'real-estate-prefooter-free-trial',
              'data-ui': 'real-estate-prefooter-free-trial'
            }}>
            {sharedT('freeTrialCTALabel')}
          </CtaDefaultMarginedMob>
        </li>
        <li>
          <Link
            href="/demo"
            variant="primary"
            customAttributes={{
              'data-gtm': 'real-estate-prefooter-demo',
              'data-ui': 'real-estate-prefooter-demo'
            }}>
            {sharedT('demoCTALabel')}
          </Link>
        </li>
      </ul>
    </PreFooter>
  );
};

export default PrefooterSection;
